import { Route, Routes } from '@angular/router';
import { CreateMetadataTagComponent } from './components/create-metadata-tags';

export const MetadataTagsRoutes: Routes = [
  {
    path: '',
    // canActivate: [AuthGaurdService],
    children: [
      <Route>{
        path: '',
        component: CreateMetadataTagComponent,
      },
    ],
  },
];
